<template>
  <el-pagination
    class="egl-pagination"
    :background="true"
    layout="prev, pager, next"
    :total="total"
    :page-size="pageSize"
    :current-page="curPage +1"
    v-on="allListeners"
  ></el-pagination>
</template>

<script>

export default {
  name: "comm-pagination",
  props: {
    total: {
      type: Number,
      required: true,
    },
    curPage: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 10,
    }
  },
  computed: {
    allListeners() {
      return Object.assign({}, this.$listeners);
    },
  },
};
</script>

<style lang="less" scoped>
  @import url('./style.less');
</style>
